export class User {
	applicationRoleId: number;
	firstName: string;
	id: number;
	lastName: string;
	email: string;
	modifiedDate: Date;
	mostRecent: boolean;
	applicationRoleName: string;
}
